import React from "react";
import "./downloadApp.css";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import Banner from "../../components/banner/banner";

const DownloadApp = () => {
  return (
    <>
      <div>
        <Header />
        <Banner />
        <section>
          <div className="content_wrapper">
            <div className="content main__content__container">
              <section className="text">
                <div className="text__container">
                  <p>
                    The fastest and easiest way to save a video is to copy a
                    link and paste it in the boxes corresponding to the price of
                    our app Link
                  </p>
                  <div className="text__desc">
                    <p>
                      TikTok, ex musically (also known as Douyin in China) is a
                      social network for viewing and creating short viral
                      videos. The application for this social network takes
                      leading positions for the number of installations
                      worldwide. The official app allows you to save your
                      videos, as well as your friends’ videos, but the bad news
                      is that each saved video will have a watermark
                    </p>
                    <p>
                      TikTokNoWatermark downloader offers you the fastest way to
                      download videos from TikTok in MP4 or mp4. Download one
                      video and see how it works.
                    </p>
                  </div>
                </div>
              </section>
              <div className="ps-5 pe-5">
                <div className="blue__block">
                  <ol>
                    <li>
                      <strong>
                        <span>
                          Download the app in the Download App box above
                        </span>
                      </strong>
                      <p>After downloading the app we come to the next step</p>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Because of privacy policy we will have a key that only
                          When you have it, you can run the App (Contact Admin)
                        </span>
                      </strong>
                      <p>
                        enter the key code in the first input box when opening
                        the app then validate key
                      </p>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Find the TikTok Username or keywords you want to
                          download
                        </span>
                      </strong>
                      <p>
                        Open the TikTok app and find the account you want to
                        save under in MP4, MP4 format and then click on that
                        account You will see the box “sidebar” at the top of the
                        screen. Tap it then press enter “Username” on the screen
                        as “tiktok” or “@tiktok”.
                        <br />
                        As for keywords, you just need to enter keywords into
                        the app to download .
                      </p>
                    </li>
                    <li>
                      <strong>
                        <span>Paste Username , keywords in App</span>
                      </strong>
                      <p>
                        You can use our TikTok MP4 downloader me on any page of
                        the App. TikTok video download to MP4 completely free
                        and in seconds!
                      </p>
                      <p>
                        Almost done. Now press the Download button and select
                        the file to save the video in your computer and then
                        download it TikTok video in MP4 format and wait for the
                        result
                      </p>
                    </li>
                    <li>
                      <strong>
                        <span>Download TikTok videos</span>
                      </strong>
                      <p>
                        If everything is fine, the "Results" page will open.
                        Scroll down to see the "Download MP4" link at the bottom
                        of the page
                      </p>
                      <p>
                        Sometimes you won't be able to see a video. This has
                        means that the video is not available for TikTok. We are
                        solve this problem and it will be fixed soon.
                      </p>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default DownloadApp;
